import coverImg from '../../../assets/images/literature/song-of-the-plug-cover.jpg';

const SEGMENTS = [
    {
        id: 'song-plug-1',
        title: 'The Country Plug',
        text: `With thumb and fore-finger worn,
With expression of infernal glee,
A country plug sat in his place of toil
Plying his dare deviltry.
Break! break! break!
As contented as cats on the rug.
And, still on a key of excellent make,
He warbled the song of the plug.

Break! break! break!
While experts grow mad and profane.
Break! break! break!
Till they think I’m a terrible bane.
Blaspheme and abuse me and swear,
Swear at, abuse me, blaspheme,
Till they’re forced, to refrain since no words remain,
To build dams for profanity’s stream.

Oh, plugs! this vast country o’er!
Fellow fiends of a calling so dire!
It is not your fingers you’re wearing out,
But the patience of kings of the wire.
Break! break! break!
As contented as puss on the rug,
Breaking on duplex and single strings too—
On all kinds considered a "bug."

Break! break! break!
My toil seems never to cease.
And what are its wages?—a cushioned chair
And a post of endless lease.
This best of wires, that longest trick,
And favors so many and great,
That my written thanks would fill all the blanks
The printers could ever create.`,
        morseText: '| | | WITH THUMB AND FORE FINGER WORN WITH EXPRESSION OF INFERNAL GLEE A COUNTRY PLUG SAT IN HIS PLACE OF TOIL PLYING HIS DARE DEVILTRY BK BREAK BREAK BREAK AS CONTENTED AS CATS ON THE RUG AND STILL ON A KEY OF EXCELLENT MAKE HE WARBLED THE SONG OF THE PLUG BK BREAK BREAK BREAK WHILE EXPERTS GROW MAD AND PROFANE BREAK BREAK BREAK TILL THEY THINK IM A TERRIBLE BANE BLASPHEME AND ABUSE ME AND SWEAR SWEAR AT ABUSE ME BLASPHEME TILL THEYRE FORCED TO REFRAIN SINCE NO WORDS REMAIN TO BUILD DAMS FOR PROFANITYS STREAM BK OH PLUGS THIS VAST COUNTRY OER FELLOW FIENDS OF A CALLING SO DIRE IT IS NOT YOUR FINGERS YOURE WEARING OUT BUT THE PATIENCE OF KINGS OF THE WIRE BK BREAK BREAK BREAK AS CONTENTED AS PUSS ON THE RUG BREAKING ON DUPLEX AND SINGLE STRINGS TOO ON ALL KINDS CONSIDERED A BUG BK BREAK BREAK BREAK MY TOIL SEEMS NEVER TO CEASE AND WHAT ARE ITS WAGES A CUSHIONED CHAIR AND A POST OF ENDLESS LEASE THIS BEST OF WIRES THAT LONGEST TRICK AND FAVORS SO MANY AND GREAT THAT MY WRITTEN THANKS WOULD FILL ALL THE BLANKS THE PRINTERS COULD EVER CREATE BK',
        questions: [
            {
                id: 'plug-q1',
                question: 'Which fingers does the "plug" use to operate the key?',
                options: ['INDEX AND MIDDLE', 'THUMB AND FORE-FINGER', 'THUMB AND PINKY', 'ALL TEN FINGERS'],
                answer: 'THUMB AND FORE-FINGER',
                difficulty: 'Beginner'
            },
            {
                id: 'plug-q2',
                question: 'What are the experts "forced to build" because of the plug?',
                options: ['NEW TELEGRAPH LINES', 'DAMS FOR PROFANITYS STREAM', 'BETTER Morse KEYS', 'STRONGER BATTERIES'],
                answer: 'DAMS FOR PROFANITYS STREAM',
                difficulty: 'Intermediate'
            }
        ]
    },
    {
        id: 'song-plug-2',
        title: 'The Experts Nightmare',
        text: `Break! break! break!
They often wish me dead,
And schemes devise to extirpate
All plugs that o’er earth are spread!
But ’tis vain to speak of death,
We never, never die.
’Tis merely a waste of experts’ breath,
They must only endure us and sigh.

Oh! but to break on a wire
Where rushists are happy and glad!
On a circuit so easy to break,
Where experts so lightly get mad.
For only one short month
To break as I used to break,
Before my fingers were stiff and old,
And my break-thirst so easy to slake.

Oh! but for one short month—
A month however short!—
(E’en February would suit me well,)
To increase my wicked sport.
A little practice would serve me much,
But to get it my work would flag;
And I could not provoke the expert folk—
No, I can not and will not lag!

You may swear and howl and shout,
You may shout and howl and swear,
But my tribe will live and thrive and grow.
(Ah! I see you with horror stare!)
We shall live to ever afflict.
We shall thrive to perpetuate breaks.
We shall grow—increase; you shall have no peace,
Until Gabriel’s trump the world awakes.

With thumb and fore-finger worn,
With a look of infernal glee,
A fiendish plug sat in his place of toil
Plying his dare deviltry.
Break! break! break!
When currents are weak and when strong,
And still in a style that never knew Morse—
Would it might know a healthy remorse—
He merrily warbled his song.`,
        morseText: '| | | BREAK BREAK BREAK THEY OFTEN WISH ME DEAD AND SCHEMES DEVISE TO EXTIRPATE ALL PLUGS THAT OER EARTH ARE SPREAD BUT TIS VAIN TO SPEAK OF DEATH WE NEVER NEVER DIE TIS MERELY A WASTE OF EXPERTS BREATH THEY MUST ONLY ENDURE US AND SIGH BK OH BUT TO BREAK ON A WIRE WHERE RUSHISTS ARE HAPPY AND GLAD ON A CIRCUIT SO EASY TO BREAK WHERE EXPERTS SO LIGHTLY GET MAD FOR ONLY ONE SHORT MONTH TO BREAK AS I USED TO BREAK BEFORE MY FINGERS WERE STIFF AND OLD AND MY BREAK THIRST SO EASY TO SLAKE BK OH BUT FOR ONE SHORT MONTH A MONTH HOWEVER SHORT EEN FEBRUARY WOULD SUIT ME WELL TO INCREASE MY WICKED SPORT A LITTLE PRACTICE WOULD SERVE ME MUCH BUT TO GET IT MY WORK WOULD FLAG AND I COULD NOT PROVOKE THE EXPERT FOLK NO I CAN NOT AND WILL NOT LAG BK YOU MAY SWEAR AND HOWL AND SHOUT YOU MAY SHOUT AND HOWL AND SWEAR BUT MY TRIBE WILL LIVE AND THRIVE AND GROW AH I SEE YOU WITH HORROR STARE WE SHALL LIVE TO EVER AFFLICT WE SHALL THRIVE TO PERPETUATE BREAKS WE SHALL GROW INCREASE YOU SHALL HAVE NO PEACE UNTIL GABRIELS TRUMP THE WORLD AWAKES BK WITH THUMB AND FORE FINGER WORN WITH A LOOK OF INFERNAL GLEE A FIENDISH PLUG SAT IN HIS PLACE OF TOIL PLYING HIS DARE DEVILTRY BK BREAK BREAK BREAK WHEN CURRENTS ARE WEAK AND WHEN STRONG AND STILL IN A STYLE THAT NEVER KNEW MORSE WOULD IT MIGHT KNOW A HEALTHY REMORSE HE MERRILY WARBLED HIS SONG BK',
        questions: [
            {
                id: 'plug-q3',
                question: 'Which month does the plug mention specifically?',
                options: ['JANUARY', 'FEBRUARY', 'MARCH', 'DECEMBER'],
                answer: 'FEBRUARY',
                difficulty: 'Beginner'
            },
            {
                id: 'plug-q4',
                question: 'Until when does the plug say there will be "no peace"?',
                options: ['THE END OF THE MONTH', 'NEXT YEAR', 'UNTIL GABRIELS TRUMP AWAKES THE WORLD', 'UNTIL THE WIRE BREAKS'],
                answer: 'UNTIL GABRIELS TRUMP AWAKES THE WORLD',
                difficulty: 'Intermediate'
            }
        ]
    }
];

export default {
    id: 'poem-the-song-of-the-plug',
    type: 'poem',
    title: 'The Song of the Plug',
    author: 'G. W. Russell',
    publicationDate: '1882',
    coverImage: coverImg,
    genres: ['Victorian Poetry', 'Humor', 'Telegraphy', 'Satire'],
    characterLength: SEGMENTS.reduce((acc, s) => acc + s.text.length, 0),
    description: "A satirical 19th-century poem about the 'plug'—a clumsy operator who delights in interrupting the transmissions of 'experts'.",
    isNew: true,

    text: SEGMENTS.map(s => s.text).join('\n\n'),
    comprehensionQuestions: SEGMENTS.flatMap(s => s.questions),
    segments: SEGMENTS.map(s => ({
        ...s,
        comprehensionQuestions: s.questions.map(q => q.id)
    })),

    metadata: {
        setting: 'Frontier Telegraph Office',
        period: 'Late 19th Century (1882)',
        themes: ['Operator Rivalry', 'Technological Frustration', 'Persistence', 'Satire'],
        difficulty: 'Intermediate',
        estimatedReadingTimeMinutes: 5,
        stanzas: 9
    }
};
